export default __webpack_public_path__ + "img/d691bb2ab78281d9d15cd7e75344d005.png";